import { createFileRoute } from '@tanstack/react-router';
import { ProductsRegister } from '../../../features/reports/screens/ProductsRegister';

/** Owned by G25. Register — products (read view). */
export const Route = createFileRoute('/_authenticated/reports/products')({
  component: ProductsRegister,
});
